import { render, staticRenderFns } from "./public-footer.vue?vue&type=template&id=b67c1a44&scoped=true&"
import script from "./public-footer.vue?vue&type=script&lang=js&"
export * from "./public-footer.vue?vue&type=script&lang=js&"
import style0 from "./public-footer.vue?vue&type=style&index=0&id=b67c1a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67c1a44",
  null
  
)

export default component.exports